import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { eqProps, equals, propOr } from 'ramda';

const styles = StyleSheet.create({
  rowContainer: { display: 'flex', width: '100%' },
  title: { marginBottom: '16px', fontWeight: 'bold', borderBottom: '1px solid rgba(0, 0, 0, 0.34)' },
});

const ExportAgePoliciesPreview = ({ policies }) => {
  const getColor = type => eqProps(type, policies.tourplan, policies.tc) ? 'rgba(0, 0, 0, 0.77)' : '#ff4081';
  return (
    <div style={{ marginTop: '16px' }}>
      <div className={css(styles.rowContainer)}>
        <div style={{ width: '20%' }}/>
        <div style={{ textAlign: 'center', fontWeight: 'bold', paddingBottom: '16px', fontSize: '18px', width: '80%' }}>Age Policies</div>
      </div>
      <div className={css(styles.rowContainer)}>
        <div style={{ width: '20%', fontWeight: 'bold' }}>
          <div style={{ height: '38px' }}/>
          <div>Infant </div>
          <div>Child </div>
        </div>
        <div style={{ width: '39%', textAlign: 'center' }}>
          <div className={css(styles.title)}>Tourplan</div>
          <span style={{ color: getColor('infantFrom') }}>{policies.tourplan.infantFrom}</span>
          &nbsp;-&nbsp;
          <span style={{ color: getColor('infantTo') }}>{policies.tourplan.infantTo}</span>
          <br/>
          <span style={{ color: getColor('childFrom') }}>{policies.tourplan.childFrom}</span>
          &nbsp;-&nbsp;
          <span style={{ color: getColor('childTo') }}>{policies.tourplan.childTo}</span>
        </div>
        <div style={{ width: '40%', textAlign: 'center', marginLeft: '1%' }}>
          <div className={css(styles.title)}>TourConnect</div>
          <span style={{ color: getColor('infantFrom') }}>{policies.tc.infantFrom}</span>
          &nbsp;-&nbsp;
          <span style={{ color: getColor('infantTo') }}>{policies.tc.infantTo}</span>
          <br/>
          <span style={{ color: getColor('childFrom') }}>{policies.tc.childFrom}</span>
          &nbsp;-&nbsp;
          <span style={{ color: getColor('childTo') }}>{policies.tc.childTo}</span>
        </div>
      </div>
    </div>);
};

export default ExportAgePoliciesPreview;



// WEBPACK FOOTER //
// ./src/app/components/integration/export/export-content-preview/preview-age-policies.jsx